import { RequestMethod } from '../../../lib/api/api.enum';
import { Api } from '../../../lib/api/api';

export class PickingListService extends Api {
    constructor(auth_token){
        super(auth_token);
    }

    public generateCreditNotes(): Promise<any> {
        return this.api({
            method: RequestMethod.POST,
            url: "/generateCreditNotes",
        })
        .then(response => response.data);
    }
}